import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      marginTop: theme.spacing(2),
    },
  };
};
